import Postmate from "postmate";

export class Awsdk {
  protected instance: Postmate.Model;

  constructor(props = {}) {
    this.instance = new Postmate.Model(props);
  }

  public dispatch(func: ISdkTypes, args: any) {
    this.instance.then((parent) => parent.emit(func, args));
  }
}
